import { Button, Col, Input, Row, Select, Form } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import PageHeader from '../../../../shared/components/pageHeader/PageHeader';
import { useHistory, useLocation } from 'react-router-dom';
import {
  authFeatureConstants,
  DEFAULT_PAGE_SIZE,
  GUTTOR_SPACE,
  INVENTORY_MESSAGE_CONSTANTS,
  INVENTROY_CONSTANTS,
} from '../../../../shared/constants/commonConstants';
import { FETCH_INVENTORY_DASHBOARD, INVENTORY_FETCH_IP_PACKAGE } from '../../../../shared/constants/urlEndPoints';
import {
  FetchInPatientPackageRequest,
  FetchInPatientPackageResponse,
} from '../../../../shared/models/inPatient.model';
import SendRequest from '../../../../shared/services/sendRequest.service';
import { canActivate, error, extractSecondLevelBaseUrl } from '../../../../utils/utility';
import DaycarePackageList from './DaycarePackageList';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchDayCareDepartmentMaster,
} from '../../../../store/actions/hospitalAction';
import { LookUpDetail } from '../../../../shared/models/lookUp.model';
import ApplicationDetail from '../../../../shared/services/applicationDetail.service';
import NoDataFound from '../../shared/NoDataFound';
import { dashBoardRequest } from '../../../../store/actions/leftSideBarAction';
import { DaycareColumns } from '../../../../shared/constants/commonConstants';
import LoadTable from '../../shared/LoadTable';
const DaycarePackages = ({ match }: any): ReactElement => {
  const pageNumber: any = new URLSearchParams(useLocation().search).get('page');
  const [daycarePackages, setDaycarePackages] = useState(null as any);
  const [currentPage, setCurrentPage] = useState((pageNumber ? pageNumber : 1));
  const [totalRecords, setTotalRecords] = useState(0);
  const [inputSearchText, setInputSearchText] = useState('');
  const [noRecordsOnFilter, setNoRecordsOnFilter] = useState(false);
  const [filterOption, setFilterOption] = useState([] as any);
  const history = useHistory();
  const dispatch = useDispatch();
  const departmentMasterList = useSelector(
    ({ hospital: { dayCaredepartmentMaster } }: any): any =>
      dayCaredepartmentMaster,
  );
  const dashboardPayload: any = {
    title: INVENTORY_MESSAGE_CONSTANTS.title.dayCareSevices,
    url: `${process.env.REACT_APP_INVENTORY_API_BASE_URL}${FETCH_INVENTORY_DASHBOARD}`, type: INVENTROY_CONSTANTS.dayCare,
  };
  useEffect((): void => {
    if (!departmentMasterList) {
      dispatch(fetchDayCareDepartmentMaster());
    }
    loadDefault();
    if (pageNumber) {
      removeQueryParam();
    }
  }, []);

  const removeQueryParam = (): void => {
    window.history.pushState('', '', window.location.pathname);
  };

  const newDayCarePackage = (): void => {
    history.push(
      extractSecondLevelBaseUrl(match?.path) + '/new-daycare-package',
    );
  };

  const loadDefault = (): void => {
    const payload: FetchInPatientPackageRequest = {
      packageByProfileId: true,
      fetchInActiveRecord: true,
      pageNumber: currentPage,
      pageSize: DEFAULT_PAGE_SIZE,
      profileIds: [ApplicationDetail.instance.getProfileId()],
      packageType: 'DayCare',
    };
    fetchPackages(payload, false, false, true);
  };

  const fetchPackages = async (
    payload: FetchInPatientPackageRequest,
    isThrowError: boolean = false,
    isRemovePackageOnError: boolean = false, isFlag?: boolean,
  ): Promise<void> => {
    dashboardPayload.filter = {
      departmentIds: payload?.departmentIds,
      name: payload?.name,
      statusName: payload?.statusType ? payload?.statusType : 'NA',
    };
    if (!isFlag) {
      dispatch(dashBoardRequest(dashboardPayload));
    }
    const url = `${process.env.REACT_APP_INVENTORY_API_BASE_URL}${INVENTORY_FETCH_IP_PACKAGE}`;
    const response = await SendRequest.instance.post<
      FetchInPatientPackageRequest,
      FetchInPatientPackageResponse
    >(url, payload);
    if (
      response &&
      response.isSuccess &&
      response.packages &&
      response.packages.length
    ) {
      setDaycarePackages(response.packages);
      setTotalRecords(response.totalRecords);
    } else {
      if (isThrowError) {
        error('Please try again');
      }
      if (isRemovePackageOnError) {
        setDaycarePackages(null);
      }
      setNoRecordsOnFilter(true);
    }
  };
  const onPaginationData = (page: number, pagesize: number): any => {
    setCurrentPage(page);
    const payload: FetchInPatientPackageRequest = {
      packageByProfileId: true,
      fetchInActiveRecord: true,
      pageNumber: page,
      pageSize: pagesize,
      profileIds: [ApplicationDetail.instance.getProfileId()],
      packageType: 'DayCare',
    };
    fetchPackages(payload);
  };

  const onSearchByName = (inputText: string): void => {
    if (inputText.length >= 3) {
      setInputSearchText(inputText);
      const payload: FetchInPatientPackageRequest = {
        packageByProfileId: true,
        packageByDepartmentId: filterOption && filterOption.length > 0,
        fetchInActiveRecord: true,
        pageNumber: 1,
        pageSize: DEFAULT_PAGE_SIZE,
        profileIds: [ApplicationDetail.instance.getProfileId()],
        departmentIds: filterOption?.map((x: LookUpDetail): any => x.id),
        packageByName: true,
        name: inputText,
        packageType: 'DayCare',
      };
      fetchPackages(payload, false, true);
      setCurrentPage(1);
    }
    if (inputText.length === 0) {
      loadDefault();
      setInputSearchText('');
    }
  };

  const onFilterByDepartment = async (
    selectedDepartments: string[],
  ): Promise<any> => {
    const dep = departmentMasterList.filter((vv: LookUpDetail): boolean => {
      return (
        selectedDepartments.findIndex((c: string): boolean => c === vv.value) >
        -1
      );
    });
    const payload: FetchInPatientPackageRequest = {
      packageByProfileId: true,
      fetchInActiveRecord: true,
      pageNumber: currentPage,
      pageSize: DEFAULT_PAGE_SIZE,
      profileIds: [ApplicationDetail.instance.getProfileId()],
      packageByDepartmentId: dep && dep.length > 0,
      departmentIds: dep?.map((x: LookUpDetail): any => x.id),
      packageType: 'DayCare',
    };
    fetchPackages(payload, false, true);
    setFilterOption(dep);
  };

  return (
    <div>
      <PageHeader
        customeClass={'inv-page-header-align'}
        pageTitle="Day Care Service"
        rightComponent={(): ReactElement => (
          <Row gutter={GUTTOR_SPACE}>
            <Col md={4} />
            <Col md={8}>
              <Select
                mode="multiple"
                className="w-100 scrollable-select mouse-pointer"
                placeholder="Department"
                optionLabelProp="label"
                allowClear={true}
                options={departmentMasterList?.map((x: any): any => {
                  return {
                    id: x.id,
                    name: x.value,
                    value: x.value,
                    key: x.id,
                  };
                })}
                onChange={onFilterByDepartment}
                value={filterOption?.map((x: LookUpDetail): any => x.value)}
              />
            </Col>
            <Col md={8}>
              <Form.Item>
                <Input
                  placeholder="Search"
                  allowClear={true}
                  ref={(input: any): any => input && input.focus()}
                  defaultValue={inputSearchText}
                  onChange={(e: any): void => onSearchByName(e.target.value)}
                />
              </Form.Item>
            </Col>

            {
              canActivate(authFeatureConstants.EDIT_DAY_CARE_SERVICES) &&
              <Col md={4}>
                <div className="text-right">
                  <Button
                    type="primary"
                    onClick={(): void => newDayCarePackage()}
                  >
                    {' '}
                    + Add Package
                  </Button>
                </div>
              </Col>
            }
          </Row>
        )}
      />
      {daycarePackages &&
        daycarePackages.length > 0 ?
        <div className="ant-tabs-content-holder tab-custom-container">
          <DaycarePackageList
            packages={daycarePackages}
            match={match}
            onPaginationEvent={onPaginationData}
            totalRecords={totalRecords}
            currentPageNo={currentPage}
          />
        </div>
        : noRecordsOnFilter ? <NoDataFound /> : <LoadTable columns={DaycareColumns} />}
    </div>
  );
};

export default DaycarePackages;
